import React, { useEffect, useState } from "react";

import { gamesService } from "../../services/Games/GamesService";
import { marketListsService } from "../../services/Markets/MarketsListService";
import { appStore } from "../../stores/appStore";

import SupperOdds from "../SuperOdds/SuperOdds";
import Markets from "../Markets/Markets";
import InfoMessages from "../InfoMessage/InfoMessage";
import Loader from "../ui-components/Loader";
import { useTranslation } from "react-i18next";
import { StyledGameOddBtn, StyledGameTableHeading } from "./GameTableStyle";
import { B2BResize } from "../../services/common/globalFunctions";

export const GameTable = () => {
  const { t } = useTranslation("General");

  const [gamesList, setGamesList] = useState([]);
  const [marketNameList, setMarketNameList] = useState([]);
  const [marketsList, setMarketsList] = useState([]);
  const [selectMarketId, setSelectMarketId] = useState(0);
  const [showMatchTable, setShowMatchTable] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  // getting and setting value in appStore
  const {
    leagueName,
    currentLeague,
    currentSeason,
    liveWeekNumber,
    setBetSlipSelections,
    betSlipSelections,
    setBetSlipDetails,
    selectedBetWeek,
  } = appStore((state) => ({
    leagueName: state.leagueName,
    currentLeague: state.currentLeague,
    currentSeason: state.currentSeason,
    liveWeekNumber: state.liveWeekNumber,
    setBetSlipSelections: state.setBetSlipSelections,
    betSlipSelections: state.betSlipSelections,
    setBetSlipDetails: state.setBetSlipDetails,
    selectedBetWeek: state.selectedBetWeek,
  }));

  // based on market selection gameTable data changing
  const onSelectMarket = (marketId) => {
    setSelectMarketId(marketId);
  };
  const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName?.leaguePrefix + currentLeague?.leagueName?.split("-")[1] : currentLeague?.leagueName;
  const setMarketsSelection = (tempGamesList) => {
    tempGamesList.forEach((game) => {
      game.markets.forEach((market) => {
        market.outComesList.forEach((outCome) => {
          outCome.selected = isOutomeSelected(game, outCome);
        });
      });
    });
    return tempGamesList;
  };
  const isOutomeSelected = (game, outCome) => {
    let isOutComeSelected = false;
    const gameSelection = betSlipSelections.filter((selection) => {
      return selection.game_id === game._id;
    });
    if (gameSelection.length > 0) {
      isOutComeSelected =
        gameSelection[0].selectedMarket.selectedOutCome._id === outCome._id;
    }
    return isOutComeSelected;
  };

  // if betslipSelection change then gameList updating
  useEffect(() => {
    const tempGamesList = setMarketsSelection(gamesList);
    setGamesList(tempGamesList);
  }, [betSlipSelections]);

  // odds selections
  const onSelectOdd = (game, market, outCome, gameIndex) => {
    game.markets.forEach((marketObj) => {
      marketObj.outComesList.forEach((outcomeObj) => {
        if (outcomeObj._id !== outCome._id) {
          outcomeObj.selected = false;
        }
      });
    });

    outCome.selected = !outCome.selected;
    let tempGamesList = [...gamesList];
    tempGamesList[gameIndex] = { ...game };
    setGamesList(tempGamesList);

    let fkLeagueId = "";
    let fkSeasonId = "";
    let fkWeekId = "";
    let selections = [];
    tempGamesList.forEach((gameObj) => {
      fkLeagueId = gameObj.fkLeagueId;
      fkSeasonId = gameObj.fkSeasonId;
      fkWeekId = gameObj.fkWeekId;
      gameObj.markets.forEach((marketObj) => {
        marketObj.outComesList.forEach((outComeObj) => {
          if (outComeObj.selected) {
            selections.push({
              game_id: gameObj._id,
              gameId: gameObj.gameId,
              gameName: gameObj.gameName,
              homeTeam: gameObj.homeTeam.teamName,
              awayTeam: gameObj.awayTeam.teamName,
              selectedMarket: {
                marketId: marketObj.marketId,
                marketName: marketObj.marketName,
                selectedOutCome: {
                  _id: outComeObj._id,
                  outComeId: outComeObj.outComeId,
                  outcomeName: outComeObj.outcomeName,
                  outcomeValue: outComeObj.outcomeValue,
                  odds: outComeObj.odds,
                },
              },
            });
          }
        });
      });
    });
    console.log({
      fkLeagueId: fkLeagueId,
      fkSeasonId: fkSeasonId,
      fkWeekId: fkWeekId,
    });
    setBetSlipDetails({
      betType: selections?.length > 1 ? "COMBO_BET" : "SINGLE_BET",
      fkLeagueId: fkLeagueId,
      fkSeasonId: fkSeasonId,
      fkWeekId: fkWeekId,
    });
    setBetSlipSelections(selections);
  };

  // fetching markets data from server
  useEffect(() => {
    const getMarketsList = async () => {
      // setShowLoader(true);
      const response = await marketListsService.getMarketsList();
      let data = response.data;
      if (data.length > 0) {
        // setShowLoader(false);
        setMarketsList(data);
        setSelectMarketId(1);
      }
    };
    getMarketsList();
  }, []);

  // fetching games/1/1/1/betweekgames data from server
  useEffect(() => {
    const getBetWeekGames = async (week) => {
      setShowLoader(true);
      const response = await gamesService.getBetWeekGames(
        currentLeague.leagueId,
        currentSeason,
        liveWeekNumber + week
      );
      let data = response.data;
      if (data.length > 0) {
        setShowMatchTable(true);
        const updatedGamesList = setMarketsSelection(data);
        setGamesList(updatedGamesList);
        setMarketNameList(updatedGamesList[0].markets);
      }
      setShowLoader(false);
      setTimeout(() => {
      B2BResize("Matches Pages");
      }, 500);
    };
    if (
      currentLeague &&
      currentLeague.leagueId &&
      currentSeason &&
      liveWeekNumber >= 0
    ) {
      getBetWeekGames(selectedBetWeek);
    }
  }, [currentLeague, currentSeason, liveWeekNumber, selectedBetWeek]);

  useEffect(() => {
    setTimeout(() => {
      B2BResize("Matches Page");
    }, 1000);
  }, []);

  // in game table showing all super odds
  const selectSuperOddsMarket = () => {
    setSelectMarketId(5);
  };

  return showLoader ? (
    <div className="mb-2">
      <Loader />
    </div>
  ) : (
    liveWeekNumber >= 0 && (
      <React.Fragment>
        <div className="w-100">
          <SupperOdds
            selectSuperOddsMarket={selectSuperOddsMarket}
            viewType={"CAROUSEL"}
          />
          {showMatchTable && (
            <Markets
              onSelectMarket={onSelectMarket}
              marketsList={marketsList}
              selectMarketId={selectMarketId}
            />
          )}
          {selectMarketId === 5 ? (
            <SupperOdds selectMarketId={selectMarketId} viewType={"TABLE"} />
          ) : (
            <React.Fragment>
              {showMatchTable ? (
                <table className="table layoutFixed text-black m-0 mt-2 bg-white">
                  <thead className="bg-primary m-0 p-0 text-white">
                    <tr>
                      <StyledGameTableHeading width="55%" className="table-width ps-3 bg-primary text-white">
                        {t(`${leagueDisplayName}`)} {t("Season")} #
                        {currentSeason},{" "}
                        <span className="week-name">
                          {t("Week")} {liveWeekNumber + selectedBetWeek}
                        </span>
                      </StyledGameTableHeading>
                      {marketNameList.map((market, index) => {
                        return (
                          market.marketId === selectMarketId && (
                            <React.Fragment key={market.marketId + "_" + index}>
                              {market.outComesList.map((outCome) => (
                                <StyledGameTableHeading
                                  className="p-1 pe-2 text-center bg-primary text-white"
                                  key={outCome._id}
                                  valign="middle"
                                >
                                  {t(`${outCome.outcomeName}`)}
                                </StyledGameTableHeading>
                              ))}
                            </React.Fragment>
                          )
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {gamesList.map((game, gameIndex) => {
                      return (
                        <tr key={game.gameId + gameIndex} className="bg-white">
                          <td className="flex-column ps-3 bg-li bg-white">
                            <div className="d-flex align-items-center mb-2">
                              <img
                                width={"24px"}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/teams/" + game?.leagueRef + "/" +
                                  game.homeTeam.teamImageURL
                                }
                                className="pe-1"
                                alt=""
                              />
                              <strong className="ms-1 text-truncate text-dark flex-fill">
                                {t(`${game.homeTeam.teamName}`)}
                              </strong>
                            </div>
                            <div className="d-flex align-items-center">
                              <img
                                width={"24px"}
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/teams/" + game?.leagueRef + "/" +
                                  game.awayTeam.teamImageURL
                                }
                                className="pe-1"
                                alt=""
                              />
                              <strong className="ms-1 text-truncate text-dark flex-fill">
                                {t(`${game.awayTeam.teamName}`)}
                              </strong>
                            </div>
                          </td>
                          {game.markets.map((market, index) => {
                            return (
                              market.marketId === selectMarketId && (
                                <React.Fragment
                                  key={market.marketName + "_" + market.marketId}
                                >
                                  {market.outComesList.map((outCome) => (
                                    <td
                                      className="p-1 pe-2 text-center bg-white"
                                      key={outCome?._id + "_" + outCome?.outComeId}
                                      valign="middle"
                                    >
                                      <StyledGameOddBtn selected={outCome.selected}
                                        className={`btn btn-lg market-outcome w-100 rounded border ${outCome.selected
                                          ? "bg-secondary text-white border-secondary"
                                          : "odds-btn text-black bg-light border border-light"
                                          }`}
                                        onClick={(e) =>
                                          onSelectOdd(
                                            game,
                                            market,
                                            outCome,
                                            gameIndex
                                          )
                                        }
                                      >
                                        {outCome.odds.toFixed(2)}
                                      </StyledGameOddBtn>
                                    </td>
                                  ))}
                                </React.Fragment>
                              )
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <InfoMessages
                  messages={`${currentLeague.leagueName
                    ? `${t(`${currentLeague.leagueName}`)} `
                    : ""
                    } ${t("No Matches Currently Available.")}`}
                />
              )}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    )
  );
};
